import { Button } from "@ui/Button";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Heading } from "@ui/typography/Heading";
import { Text } from "@ui/typography/Text";

type Props = {
	onClick: () => void;
};
export const ChatCard = (props: Props) => {
	return (
		<HStack spacing="large">
			<div class="icon-bg">
				<MaterialSymbol symbol="support_agent" />
			</div>
			<VStack spacing="medium">
				<VStack spacing="small">
					<Heading as="h3" weight="semi-bold">
						Round-the-clock support
					</Heading>
					<Text color="fg3">
						Account questions, onboarding, anything you're stuck on.
					</Text>
				</VStack>
				<Button
					variant="tertiary"
					symbol="open_in_new"
					onClick={() => {
						// @ts-expect-error Crisp's loader is defined by layouts/app.blade.php
						window.gvtLoadCrisp?.();
						// @ts-expect-error Crisp chat is injected globally
						$crisp.push(["do", "chat:show"]);
						// @ts-expect-error Crisp chat is injected globally
						$crisp.push(["do", "chat:open"]);
						props.onClick();
					}}
					symbolPosition="after"
				>
					Chat with us
				</Button>
			</VStack>
		</HStack>
	);
};
